export enum MarketToCustomers {
	HIDDEN = "HIDDEN",
	VISIBLE = "VISIBLE",
}

export enum OnlineOrdering {
	DISABLED = "DISABLED",
	ENABLED = "ENABLED",
}

export interface VisibilityValues {
	marketToCustomers?: MarketToCustomers
	onlineOrdering?: OnlineOrdering
}
